import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { gridSizeMdLg6, newTipoInstalacionSchema, ROUTER_PATHS } from '@/shared';
import {
  CreateTipoInstalacionParams,
  useCreateTipoInstalacion,
  useUpdateTipoInstalacion,
} from '@/shared/actions/erp';
import {
  CustomNumberTextField,
  CustomTextField,
  SampleCheckbox,
  SingleFormBoxScene,
} from '@/shared/components/ui';
import { TipoInstalacion } from '@/shared/interfaces';

export interface SaveTipoInstalacionInterface {
  titlePage: string;
  editTipoInstalacion?: TipoInstalacion;
}

type SaveFormData = CreateTipoInstalacionParams & {};

const returnUrlTiposInstalacion =
  ROUTER_PATHS.administration.tiposInstalacionNav;

const SaveTipoInstalacion: React.FC<SaveTipoInstalacionInterface> = ({
  titlePage,
  editTipoInstalacion,
}) => {
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

  ///* mutations
  const createTipoInstalacionMutation = useCreateTipoInstalacion(
    navigate,
    returnUrlTiposInstalacion
  );
  const updateTipoInstalacionMutation = useUpdateTipoInstalacion(
    navigate,
    returnUrlTiposInstalacion
  );

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newTipoInstalacionSchema) as any,
    defaultValues: {
      estado: true,
    },
  });
  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  ///* handlers
  const onSave = () => {
    if (!isValid) return;

    ///* upd
    if (editTipoInstalacion?.id_instalacion) {
      return updateTipoInstalacionMutation.mutate({
        id: editTipoInstalacion.id_instalacion,
        data: form.getValues() as any,
      });
    }

    ///* create
    return createTipoInstalacionMutation.mutate(form.getValues() as any);
  };

  ///* effects
  useEffect(() => {
    if (editTipoInstalacion?.id_instalacion) {
      setShrink(true);
      reset({
        ...editTipoInstalacion,
      });
    }
  }, [editTipoInstalacion]);

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlTiposInstalacion);
      }}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        label="Nombre"
        name="nombre"
        control={form.control}
        defaultValue={form.getValues().nombre || ''}
        error={errors.nombre}
        helperText={errors.nombre?.message?.toString() ?? ''}
        size={gridSizeMdLg6}
        shrink={shrink}
      />
     {/*  <CustomTextField
        label="Código"
        name="codigo"
        control={form.control}
        defaultValue={form.getValues().codigo || ''}
        error={errors.codigo}
        helperText={errors.codigo?.message?.toString() ?? ''}
        disabled={!!editTipoInstalacion?.id_instalacion}
        size={gridSizeMdLg6}
        shrink={shrink}
      /> */}

      <CustomTextField
        label="Número de referencia"
        name="numero_referencia"
        control={form.control}
        defaultValue={form.getValues().numero_referencia || ''}
        error={errors.numero_referencia}
        helperText={errors.numero_referencia?.message?.toString() ?? ''}
        size={gridSizeMdLg6}
        shrink={shrink}
      />

      <CustomNumberTextField
        label="Valor"
        name="valor"
        control={form.control}
        defaultValue={form.getValues().valor || ''}
        error={errors.valor}
        helperText={errors.valor?.message?.toString() ?? ''}
        size={gridSizeMdLg6}
        min={0}
        shrink={shrink}
        required={false}
      />

      <SampleCheckbox
        label="Estado"
        name="estado"
        control={form.control}
        defaultValue={!!form.getValues().estado}
        isState
        size={gridSizeMdLg6}
      />
    </SingleFormBoxScene>
  );
};

export default SaveTipoInstalacion;
